import { useEffect, useRef, useState } from 'react';

import formbricks from '@formbricks/js';
import { useLocation } from 'react-router-dom';

import { getCountry } from '../iwIntlProvider/CountryProvider';
import { logError } from '../iwLogger/IwDataDogLogger';
import { useStateKey } from '../iwQueryClient/useStateKey';

export const FormbricksProvider = () => {
    const isInitializing = useRef(false);
    const [isInitialized, setIsInitialized] = useState(false);
    const location = useLocation();
    const stateKey = useStateKey();

    useEffect(() => {
        const isProduction = ['www.iwoca.co.uk', 'www.iwoca.de'].includes(
            window.location.host
        );
        const envId = isProduction
            ? import.meta.env.VITE_FORMBRICKS_ENV_ID_PRODUCTION
            : import.meta.env.VITE_FORMBRICKS_ENV_ID_STAGING;

        if (!envId) {
            console.warn(
                'Formbricks: Missing VITE_FORMBRICKS_ENV_ID_STAGING or VITE_FORMBRICKS_ENV_ID_PRODUCTION environment variable'
            );
            return;
        }

        if (getCountry() !== 'DE') return;
        if (isInitializing.current || isInitialized) return;

        isInitializing.current = true;

        formbricks
            .setup({
                environmentId: envId,
                appUrl: 'https://app.formbricks.com'
            })
            .then(() => {
                setIsInitialized(true);
            })
            .catch((error) => {
                logError(
                    'Formbricks initialization failed',
                    { tags: { component: 'FormbricksProvider' }, envId },
                    error
                );
            });
    }, [isInitialized]);

    useEffect(() => {
        if (!isInitialized) return;
        if (!stateKey || getCountry() !== 'DE') return;
        formbricks.setUserId(stateKey);
    }, [isInitialized, stateKey]);

    useEffect(() => {
        if (!isInitialized) return;
        if (getCountry() !== 'DE') return;
        formbricks.registerRouteChange();
    }, [isInitialized, location.pathname, location.search]);

    return null;
};
